// extracted by mini-css-extract-plugin
export default {"modal":"Oja-z","header":"Pja-z","fields":"Qja-z","error":"Rja-z","disabled":"Sja-z","reminderMsg":"Tja-z","errorMsg":"Uja-z","footer":"Vja-z"};